import { render, staticRenderFns } from "./ProductStoreStock.vue?vue&type=template&id=688a5d11"
import script from "./ProductStoreStock.vue?vue&type=script&lang=js"
export * from "./ProductStoreStock.vue?vue&type=script&lang=js"
import style0 from "./ProductStoreStock.vue?vue&type=style&index=0&id=688a5d11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports